import React from 'react'
import { Helmet } from 'react-helmet-async';

function Contact() {
  return (

    <div>
      <Helmet>
        <title>Contact Us for All Your Software Download Needs</title>
        <meta property="og:title" content="Contact Us for All Your Software Download Needs"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/contact"/>
        <meta property="og:description" content="Have a question or need assistance with a software download? Our customer support team is here to help. Contact us today and get the assistance you need to download and install the latest software programs. With a commitment to providing exceptional customer service and a vast knowledge of software downloads, our team is ready to help you with any issues you may encounter. From troubleshooting to installation assistance, we're here to ensure your software download experience is as smooth and hassle-free as possible."/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="https://desirestore.online/og-images/og-home.png"/>

        <meta name="title" content="Contact Us for All Your Software Download Needs"/>
        <link rel="canonical" href="https://desireStore.online/contact" />
        <meta name="description" data-rh="true" content="Have a question or need assistance with a software download? Our customer support team is here to help. Contact us today and get the assistance you need to download and install the latest software programs. With a commitment to providing exceptional customer service and a vast knowledge of software downloads, our team is ready to help you with any issues you may encounter. From troubleshooting to installation assistance, we're here to ensure your software download experience is as smooth and hassle-free as possible."/>
        <meta name="keywords" content=" Contact Us, software download, customer support, assistance, installation, troubleshooting, customer service, smooth, hassle-free."/>
      </Helmet>
     <div className="container">
     
  <div className="contact" id="contact">
            <form action="https://formspree.io/f/mlezvvvj" method="POST" className='ContactForm'>
               
                    <h3>Contact</h3>
                
                <p>Transforming Your Ideas into Reality - Get Your Software Solutions in Days..." </p>
                <input type="text" id="name" name="name" placeholder="Your Name"   title="Enter Your Full Name" required autocomplete="additional-name"/>
                <input type="email" id="email" name="email" placeholder="Email ID" title="Enter Your Mail ID" required/>

                <input type="tel" id="phone" name="phone" placeholder="Phone Number" title="Enter Phone Number"/>
                <textarea id="massage" rows="4" name="massage" placeholder="What Is your Desire Softwere"
                    title="Type Something..."></textarea>
                    <div className="btn">
                <button type="submit" id="submit"> Send </button>
                <button type="reset"> Reset </button>
                </div>
            </form>
         
        </div>
      
      
        </div> 
        </div>
           
    
  )
}

export default Contact
